
  var _styles = {
  "horizontal-card-container": {
    "width": "4.4rem",
    "height": "6.53333rem",
    "display": "flex",
    "flexDirection": "column",
    "position": "relative",
    "borderRadius": "0.24rem",
    "backgroundColor": "rgb(255,255,255)",
    "marginRight": "0.16rem"
  },
  "horizontal-card-image-view": {
    "width": "100%",
    "height": "3.12rem",
    "overflow": "hidden",
    "borderRadius": "0.24rem 0.24rem 0 0"
  },
  "horizontal-card-image": {
    "width": "100%",
    "height": "100%",
    "borderRadius": "0.24rem 0.24rem 0 0",
    "OObjectFit": "cover",
    "objectFit": "cover"
  },
  "horizontal-card-image-tag": {
    "position": "absolute",
    "height": "0.48rem",
    "top": 0,
    "left": "-0.05333rem",
    "zIndex": 10
  },
  "horizontal-departures-container": {
    "position": "absolute",
    "left": "0.8rem",
    "top": 0,
    "zIndex": 9
  },
  "horizontal-departures-background": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "width": "100%",
    "height": "0.42667rem",
    "zIndex": 11
  },
  "horizontal-departures-text": {
    "height": "0.42667rem",
    "fontSize": "0.25333rem",
    "color": "rgb(228,225,225)",
    "zIndex": 12,
    "paddingLeft": "0.22667rem",
    "paddingRight": "0.13333rem",
    "lineHeight": "0.42667rem"
  },
  "horizontal-card-content-right": {
    "width": "100%",
    "height": "3.05333rem",
    "paddingTop": 0,
    "paddingRight": 0,
    "paddingBottom": 0,
    "paddingLeft": 0,
    "boxSizing": "border-box",
    "display": "flex",
    "flexDirection": "column"
  },
  "horizontal-card-top-field": {
    "width": "100%",
    "display": "flex"
  },
  "horizontal-card-tag-field": {
    "paddingTop": "0.13333rem",
    "paddingRight": "0.16rem",
    "paddingBottom": 0,
    "paddingLeft": "0.16rem",
    "display": "flex",
    "flexDirection": "row",
    "lineHeight": "0.53333rem",
    "fontSize": "0.37333rem",
    "fontWeight": "500",
    "color": "rgb(34,34,33)",
    "minHeight": "1.01333rem"
  },
  "horizontal-card-day-tag": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.26667rem",
    "width": "0.42667rem",
    "height": "0.42667rem",
    "overflow": "hidden",
    "borderRadius": "0.08rem",
    "lineHeight": "0.53333rem",
    "backgroundColor": "rgb(255,209,0)",
    "marginRight": "0.06667rem",
    "marginBottom": "-0.06667rem"
  },
  "horizontal-card-day-tag-text": {
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.26667rem"
  },
  "horizontal-card-day-h5-tag-text": {
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.26667rem",
    "paddingTop": "0.05333rem",
    "paddingRight": "0.08rem",
    "paddingBottom": "0.05333rem",
    "paddingLeft": "0.08rem",
    "borderRadius": "0.08rem",
    "lineHeight": "0.53333rem",
    "backgroundColor": "rgb(255,209,0)",
    "marginRight": "0.06667rem"
  },
  "horizontal-card-deal-name": {
    "fontSize": "0.37333rem",
    "width": "4.26667rem",
    "textAlign": "left",
    "verticalAlign": "bottom"
  },
  "horizontal-card-tag": {
    "width": "100%",
    "display": "flex",
    "flexDirection": "row",
    "marginTop": "0.06667rem",
    "marginRight": "0.16rem",
    "marginBottom": "0.06667rem",
    "marginLeft": "0.16rem",
    "minHeight": "0.37333rem"
  },
  "horizontal-card-bottom-field": {
    "display": "flex",
    "flexDirection": "row",
    "paddingTop": "0.25333rem",
    "paddingRight": "0.16rem",
    "paddingBottom": "0.25333rem",
    "paddingLeft": "0.16rem",
    "width": "100%",
    "minHeight": "0.96rem",
    "position": "relative",
    "alignItems": "flex-end"
  },
  "horizontal-card-bottom-left-field": {
    "display": "flex",
    "flexDirection": "column"
  },
  "horizontal-card-price-field": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-end"
  },
  "horizontal-card-price-icon": {
    "color": "rgb(255,39,39)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.32rem"
  },
  "horizontal-card-price-start": {
    "color": "rgb(255,39,39)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.32rem",
    "lineHeight": "0.4rem",
    "marginLeft": "0.02667rem",
    "marginRight": "0.08rem"
  },
  "horizontal-card-price-now": {
    "color": "rgb(255,39,39)",
    "fontFamily": "MTfin2.0",
    "fontWeight": "600",
    "fontSize": "0.48rem"
  },
  "horizontal-card-price-price": {
    "color": "rgb(255,39,39)",
    "fontFamily": "MTfin2.0",
    "fontWeight": "600",
    "lineHeight": "0.6rem",
    "fontSize": "0.48rem"
  },
  "horizontal-card-price-origin": {
    "color": "rgb(102,102,102)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.32rem",
    "lineHeight": "0.4rem",
    "textDecoration": "line-through",
    "marginBottom": "0.05333rem"
  },
  "horizontal-card-discount-width-field": {
    "display": "flex",
    "flexDirection": "row"
  },
  "horizontal-card-discount-left-field": {
    "alignSelf": "flex-start",
    "borderTopLeftRadius": "0.08rem",
    "borderBottomLeftRadius": "0.08rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "height": "0.37333rem"
  },
  "horizontal-card-discount-img": {
    "width": "0.37333rem",
    "height": "0.37333rem"
  },
  "horizontal-card-discount-width-text": {
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.26667rem"
  },
  "horizontal-card-discount-right-field": {
    "alignSelf": "flex-start",
    "borderTopRightRadius": "0.08rem",
    "borderBottomRightRadius": "0.08rem",
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderColor": "rgb(255,75,16)",
    "height": "0.37333rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "horizontal-card-curve-img": {
    "width": "0.16rem",
    "height": "0.36rem"
  },
  "horizontal-card-reduce-text": {
    "color": "rgb(255,75,16)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "lineHeight": "0.32rem",
    "marginRight": "0.08rem"
  },
  "horizontal-card-discount-field": {
    "display": "flex",
    "flexDirection": "row",
    "alignSelf": "flex-start",
    "borderRadius": "0.08rem"
  },
  "horizontal-card-discount-text": {
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.26667rem",
    "lineHeight": "0.37333rem",
    "marginRight": "0.08rem",
    "marginTop": "0.01333rem"
  },
  "horizontal-card-bottom-right-field": {
    "borderRadius": "0.4rem",
    "height": "0.8rem",
    "width": "1.38667rem",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "position": "absolute",
    "right": "10rpx",
    "top": "0.48rem"
  },
  "horizontal-card-bottom-right-text": {
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.37333rem",
    "lineHeight": "0.42667rem"
  },
  "horizontal-card-product-tag-free": {
    "borderRadius": "0.08rem",
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderColor": "rgba(7,119,238,0.2980392157)",
    "marginRight": "0.08rem",
    "whiteSpace": "nowrap"
  },
  "horizontal-card-product-tag-text-free": {
    "color": "rgb(7,119,238)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "marginTop": 0,
    "marginRight": "0.08rem",
    "marginBottom": 0,
    "marginLeft": "0.08rem"
  },
  "horizontal-card-product-tag-group": {
    "borderRadius": "0.08rem",
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderColor": "rgba(77,153,0,0.2980392157)",
    "marginRight": "0.08rem",
    "whiteSpace": "nowrap"
  },
  "horizontal-card-product-tag-text-group": {
    "color": "rgb(77,153,0)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "marginTop": 0,
    "marginRight": "0.08rem",
    "marginBottom": 0,
    "marginLeft": "0.08rem"
  },
  "horizontal-card-people-tag": {
    "borderRadius": "0.08rem",
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderColor": "rgba(142,60,18,0.2980392157)",
    "marginRight": "0.08rem"
  },
  "horizontal-card-people-tag-text": {
    "color": "rgb(142,60,18)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "marginTop": 0,
    "marginRight": "0.08rem",
    "marginBottom": 0,
    "marginLeft": "0.08rem"
  }
};

  if (typeof FontFace === 'function') {
    
    var fontFace0 = new FontFace('MTfin-Regular2_0', 'url("https://s3plus.meituan.net/v1/mss_098f084b61e744a0ae960d755eaad45e/meishi-yingxiao/fonts/max-icon/MTfin-Regular2.0.ttf")');
    document.fonts.add(fontFace0);
    
  }
    


  module.exports = _styles;
  